
import React from 'react';
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from 'react-i18next';

interface ContentEditorProps {
  content: string;
  onChange: (content: string) => void;
  onEnterPress?: () => void;
}

export const ContentEditor = ({ content, onChange, onEnterPress }: ContentEditorProps) => {
  const { t } = useTranslation();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && onEnterPress) {
      e.preventDefault();
      onEnterPress();
    }
  };

  return (
    <div className="grid gap-2">
      <Label htmlFor="content">{t('common.content')}</Label>
      <Textarea
        id="content"
        value={content}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className="min-h-[200px]"
      />
    </div>
  );
};
